import React, { ReactNode } from "react";
import { ThemeProvider as EmotionThemeProvider, Theme } from "@emotion/react";
import { compassColors } from "./utils/styling";
import { isCalorieClinicalRoute } from "./utils/userSegment";
import { isClinical32pxButtonRadiusActive } from "./utils/userSegment/features";

const defaultTheme: Theme = {
  themeName: "DEFAULT",
  buttonRadius: isClinical32pxButtonRadiusActive() && "32px",
  button: {
    primary: {
      enabled: {
        background: compassColors.tarocco,
      },
      hover: {
        background: compassColors.cinnamon,
      },
      focus: {
        background: compassColors.cinnamon,
      },
      borderRadius: isClinical32pxButtonRadiusActive() ? "32px" : "4px",
    },
    medPrimary: {
      enabled: {
        background: compassColors.lagoon,
      },
    },
    medPrimaryCta: {
      borderRadius: isClinical32pxButtonRadiusActive() ? "32px" : "8px",
    },
    secondary: {
      borderRadius: "4px",
      hover: {
        background: compassColors.offWhite,
        color: compassColors.tarocco,
      },
    },
    designStyle: {
      style1: "primaryCta",
    },
  },
  progressBar: {
    background: compassColors.lagoon,
  },
  background: {
    background1: compassColors.blueberry,
    background2: compassColors.blueberry,
    background3: compassColors.blueberry,
    background4: compassColors.sky,
  },
  textColor: {
    color1: compassColors.white,
  },
};

const calorieTheme: Theme = {
  themeName: "CALORIE",
  buttonRadius: isClinical32pxButtonRadiusActive() && "32px",
  button: {
    primary: {
      enabled: {
        background: compassColors.black,
      },
      hover: {
        background: compassColors.grey4,
      },
      focus: {
        background: compassColors.tarocco,
      },
      borderRadius: isClinical32pxButtonRadiusActive() ? "32px" : "56px",
    },
    medPrimary: {
      enabled: {
        background: compassColors.black,
      },
    },
    medPrimaryCta: {
      borderRadius: isClinical32pxButtonRadiusActive() ? "32px" : "56px",
    },
    secondary: {
      borderRadius: "56px",
      hover: {
        background: compassColors.sand1,
        color: compassColors.black,
      },
    },
    designStyle: {
      style1: "secondaryCta",
    },
  },
  progressBar: {
    background: compassColors.black,
  },
  background: {
    background1: compassColors.black,
    background2: compassColors.lagoon,
    background3: compassColors.offWhite,
    background4: compassColors.offWhite,
  },
  textColor: {
    color1: compassColors.black,
  },
};

interface ThemeProviderProps {
  children: ReactNode;
}

/* Theme provider wrapper for the buyflow, see https://emotion.sh/docs/theming for examples on how to use */
export function ThemeProvider({ children }: ThemeProviderProps) {
  let theme = defaultTheme;
  if (isCalorieClinicalRoute()) {
    theme = calorieTheme;
  }

  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>;
}
